/* eslint-disable react/forbid-prop-types */
import React, { useEffect, useState, useCallback } from 'react';
import PropTypes from 'prop-types';

function Links(props) {
  const { children, stickyNavRef } = props;
  const [activeLink, setActiveLink] = useState('');

  const SCROLL_BUFFER_Y = 25;

  useEffect(() => {
    const handleScroll = () => {
      const refs = React.Children.map(children, (el) => {
        return {
          rect: el.props?.targetRef?.current?.getBoundingClientRect(),
          id: el.props?.targetRef?.current?.id
        };
      });

      const firstElement = refs.filter((ref) => {
        if (ref.rect === null || ref.rect === undefined) {
          return false;
        }

        const navHeight = stickyNavRef?.current?.getBoundingClientRect().height;

        const topIsOnScreen = ref.rect.top > navHeight + SCROLL_BUFFER_Y
          && ref.rect.top < window.innerHeight;
        const bottomIsOnScreen = ref.rect.bottom > navHeight + SCROLL_BUFFER_Y
          && ref.rect.bottom <= window.innerHeight + navHeight;

        // If top or bottom is on screen, then it is visible.
        if (topIsOnScreen || bottomIsOnScreen) {
          return true;
        }

        return ref.rect.top < navHeight + SCROLL_BUFFER_Y
            && ref.rect.bottom > window.innerHeight;

      }) // Order them by vertical offset, and take the first one
        .sort((first, second) => Math.abs(first.rect.top) - Math.abs(second.rect.top))[0];

      if (activeLink !== firstElement?.id) {
        setActiveLink(firstElement?.id);
      }
    };

    window.addEventListener('scroll', handleScroll, { passive: true });

    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [activeLink]);

  const markActiveElement = (child) => {
    if (child.props.targetRef?.current?.id === activeLink) {
      return React.cloneElement(child, { className: 'active' });
    }
    return child;
  };

  return (
    <ul>
      {React.Children.map(children, markActiveElement)}
    </ul>
  );
}

Links.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.node,
    PropTypes.arrayOf(PropTypes.node)
  ]),
  stickyNavRef: PropTypes.shape({ current: PropTypes.any })
};
Links.defaultProps = {
  children: null,
  stickyNavRef: null
};

export default Links;
